<template>
    <div class="cgs-register-step step-one">
        <div class="register-input-container">
            <van-field v-model="name" placeholder="请输入姓名" />
        </div>
        <div class="register-input-container">
            <van-field v-model="tel" type="digit" placeholder="请输入手机号码" :error-message="telError" @blur="setTel" />
        </div>
        <div class="register-input-container">
            <van-field v-model="code" center clearable placeholder="请输入短信验证码" :error-message="codeError">
                <template #button>
                    <div v-if="codeLoading">
                        <van-loading size="20px">{{ codeLoadingTime + 's' }}</van-loading>
                    </div>
                    <span @click="sendCode" v-else>发送验证码</span>
                </template>
            </van-field>
        </div>
        <div class="register-input-container">
            <van-field v-model="password" placeholder="请输入密码" type="password" />
        </div>
        <div class="register-input-container" v-if="tenantId === ''">
            <van-field v-model="orgId" placeholder="输入已有组织ID" />
        </div>
        <div class="register-input-container">
            <van-button type="info" style="width: 100%" :loading="registerLoading" @click="nextStep">注册</van-button>
        </div>
    </div>
</template>

<script>
import { Field, Button, Loading } from 'vant';
import { checkByUsername, getValidationCode, checkValidationCode, register } from "@/api/authority"
import qs from 'qs'

export default {
    components: {
        vanField: Field,
        vanButton: Button,
        vanLoading: Loading
    },
    data() {
        return {
            name: '',
            tel: '',
            code: '',
            password: '',
            orgId: '',
            tenantId: '',
            telError: '',
            codeError: '',
            registerLoading: false,
            codeLoading: false,
            codeTimer: null,
            codeLoadingTime: 60
        }
    },
    created(){
      this.tenantId = process.env.VUE_APP_TENANTID
      if(this.tenantId !== ''){
        this.orgId = this.tenantId
      }
    },
    methods: {
        testTel() {
            let reg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;//正则表达式
            return reg.test(this.tel);//正则表达式的test()方法，返回值Boolen
        },
        setTel() {
            if (this.testTel()) {
                // this.telError = ''
            } else {
                this.$Notify({ type: "danger", message: '手机号码格式错误' });
            }
        },
        setCodeLoading() {
            this.codeLoading = true
            this.codeTimer = setInterval(() => {
                if (this.codeLoadingTime === 0) {
                    clearInterval(this.codeTimer)
                    this.codeTimer = null
                    this.codeLoading = false
                    this.codeLoadingTime = 60
                }
                this.codeLoadingTime--
            }, 1000)
        },
        async sendCode() {
            if (!this.testTel()) {
                this.$Notify({ type: "danger", message: '手机号码格式错误' });
                return
            }
            try {
                let checkResult = await checkByUsername(this.tel)
                if (checkResult.code === 200) {
                    if (checkResult.data.isExist) {
                        this.$Notify({ type: "danger", message: '该手机号码已经注册' });
                    } else {
                        this.setCodeLoading()
                        let codeResult = await getValidationCode(this.tel)
                        if (codeResult.code === 200) {
                            this.$Notify({ type: "success", message: "验证码已发送" });
                        }
                    }
                }
            } catch (err) {
            }
        },
        async nextStep() {
            if (this.name === '' || this.password === '' || this.tel === '' || this.orgId === '' || this.code === '') {
                this.$Notify({ type: "danger", message: '请将信息填写完整' });
                return
            }
            try {
                this.registerLoading = true
                let checkResult = await checkValidationCode(this.tel, this.code)
                if (checkResult.code === 200) {
                    let params = {
                        nickName: this.name,
                        password: this.password,
                        phoneNumber: this.tel,
                        tenantId: this.orgId,
                        type: 1,
                        "validationCode": this.code
                    }
                    let registerResult = await register(params)
                    if (registerResult.code === 200) {
                        this.$router.push('/login')
                        this.$Notify({ type: "success", message: "注册成功，请登录" });
                    } else {
                        this.$Notify({ type: "danger", message: registerResult.msg });
                    }
                } else if (checkResult.code === 300) {
                    this.$Notify({ type: "danger", message: checkResult.msg });
                }
                this.registerLoading = false
            } catch (err) {
                this.registerLoading = false
            }
        }
    }

}
</script>

<style scoped>
.cgs-register-step {
    padding: 0px 40px;
}

.register-input-container {
    margin-bottom: 15px;
}
</style>

<style>
.cgs-register-step .van-cell {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
}
</style>